import React from 'react';
import { Button } from '@kaizen/button';
import chevronLeftIcon from '@kaizen/component-library/icons/chevron-left.icon.svg';
import chevronRightIcon from '@kaizen/component-library/icons/chevron-right.icon.svg';

type Props = {
  label: string;
  'aria-label': string;
  index: number;
  textDirection: 'rtl' | 'ltr';
};

const NextButton = (props: Props): React$Element<string> => {
  const { label, index, textDirection, 'aria-label': ariaLabel } = props;

  const handleClick = (): void => {
    // Send a custom event back to response.js, with the accordion logic still in Haml/jQuery
    $(document).trigger('reactNextButton', { index: index });
  };

  return (
    <Button
      label={label}
      aria-label={ariaLabel}
      onClick={handleClick}
      icon={textDirection === 'rtl' ? chevronLeftIcon : chevronRightIcon}
      iconPosition="end"
    />
  );
};

export default NextButton;
